<template>
    <label class="text-sm block text-cavilam-primary font-semibold" :for="name">
        {{ __(libelle) }} <sup v-show="required" class="text-red-500">*</sup>
    </label>
    <select :id="name" v-model="$parent.form[name]"
            :name="name"
            :class="{'pointer-events-none opacity-75':readonly}"
            class="w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
            :required="required">
        <option :value="null"> -- {{ __('veuillez_selectionner_pays') }} -- </option>
        <option v-for="pays in liste" :value="pays.code">{{ pays.libelle }}</option>
    </select>
    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors[name]}">{{ __($parent.form.errors[name]) }}</p>
</template>

<script>
export default {
    name: "PaysSelector",
    props: {
        name: String,
        libelle: String,
        liste: Array,
        required: Boolean,
        readonly: Boolean
    },
}
</script>

<style scoped>

</style>
